<div class="pr-10 gap-6 flex flex-col">
  <div class="flex w-full justify-between bg-white p-2 items-center rounded-lg">
    <!-- <span>{{ AccountHolderName  }}</span> -->
    <span>Customer Profile Edit</span>
    <div class="flex gap-2">
      <!-- <app-secondary-button (click)="submitCustomerData()"
        >Save</app-secondary-button
      > -->
      <!-- <app-primary-button (click)="submitCustomerData()"
        >Draft</app-primary-button
      > -->
    </div>
  </div>
  <!-- Action -->

  <!-- <div class="flex w-full flex-col bg-white py-2 rounded-xl">
    <form [formGroup]="customerBasicForm" >
    <div
      class="flex w-full justify-between bg-white py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
    >
      <div class="flex gap-4">
        <div class="h-10 w-1 bg-primary"></div>
        <span>Action</span>
      </div>
      <div class="p-1 rounded-full h-6 w-6 bg-gray-300">
        <img src="../../../assets/image/Arrows.svg" />
      </div>
    </div>
    <div class="p-5 flex gap-4">
      <div class="w-full gap-2 flex flex-col">
        <span>Title Text</span>
        <input
        formControlName="Title"
        name="Title"
          class="w-full border p-2 rounded-md outline-none"
          [placeholder]="'Enter Title Text'"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Title Text</span>

        <input
        formControlName="Title"
        name="Title"
          placeholder="Enter Title Text"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
    </div>
    <div class="p-5 flex gap-4">
      <div class="w-full gap-2 flex flex-col">
        <span>Comments</span>

        <input
        formControlName="comments"
        name="comments"
          placeholder="Max 200 characters"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
    </div>
    </form>
  </div> -->
  <!--Personal Details  -->
  <app-customer-profile-personal-details></app-customer-profile-personal-details>

  <!-- Contact Details -->
  <!-- <app-customer-profile-contact-detail></app-customer-profile-contact-detail> -->

  <!-- Notificati Setting -->
  <app-customer-profile-notification-setting></app-customer-profile-notification-setting>
  <!-- Transaction Flag -->
  <app-customer-profile-transactional-flag></app-customer-profile-transactional-flag>
  <!-- Naming Convention -->
  <app-customer-profile-naming-convention></app-customer-profile-naming-convention>
  <!-- Business Details -->
  <app-customer-business-details></app-customer-business-details>
  <!-- Scheme Seting -->
  <app-custumer-customerprofile-schememanager></app-custumer-customerprofile-schememanager>
  <div
    class="w-full justify-end flex items-center gap-4 px-5 bg-white rounded-xl py-3"
  >
    <app-primary-button (click)="submitCustomerData()">Save</app-primary-button>
    <!-- <app-primary-button (click)="submitCustomerData()"

      >Draft</app-primary-button -->
    <!-- > -->
  </div>
</div>
